<template>
  <v-main class="pa-4" fluid>
   
     <v-snackbar v-model="snackbar" :timeout="8000" top :color="color" >  {{text}}
        <v-btn color="white" text @click="snackbar = false"> Cerrar </v-btn>
      </v-snackbar>

    <v-row >
      <v-col>
        <v-card  class="shadowCard" >
          <v-card-title primary-title>
            <span class="text-h5 font-weight-bold"> Novedades </span>
            <v-spacer></v-spacer>
            <v-btn color="secondary" dark class="mr-2" @click="init()">  Actualizar </v-btn>
            <v-btn color="primary"   dark class="ma-2" @click="exportar()"> <v-icon>save_alt</v-icon> </v-btn>
          </v-card-title>

          <v-card-text>
            <v-row justify="end">
              <v-spacer></v-spacer>
                <v-col cols="12" md="4" lg="3">
                  <v-text-field
                    name="name"
                    label="Buscar"
                    id="id"
                    dense
                    hide-details
                    append-icon="mdi-magnify" 
                    v-model="search"
                    clearable
                  ></v-text-field>
                </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-data-table
                  :loading="loading"        
                  :headers="headers"
                  :items="productos"
                  class="elevation-0"
                  :search="search"
                  :height="tamanioPantalla"
                  fixed-header
                  hide-default-footer
                  :page.sync="page"
                  :items-per-page="itemsPerPage"
                  @page-count="pageCount = $event"
                  dense
                >
                  <template v-slot:no-data>
                    <v-alert type="info" color="primary" outlined :value="true">
                      No hay datos para mostrar
                    </v-alert>
                  </template>

                  <template v-slot:item.novedades = "{item}">
                    <v-checkbox v-model="item.novedades" dense hide-details class="mt-0" @change="novedades(item)"></v-checkbox>
                  </template>

                  <template v-slot:item.destacados = "{item}">
                    <v-checkbox v-model="item.destacados" dense hide-details class="mt-0" @change="novedades(item)"></v-checkbox>
                  </template>

                  <template v-slot:item.juguete = "{item}">
                    <v-checkbox v-model="item.juguete" dense hide-details class="mt-0" @change="novedades(item)"></v-checkbox>
                  </template>
                          
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
            
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-pagination
              circle
              v-model="page"
              :length="pageCount"
              :total-visible="7"
            ></v-pagination>
          </v-card-actions>

          </v-card>

      </v-col>

    </v-row>  
  </v-main>
</template>


<script>
  import  metodos from '@/mixins/metodos.js';
  import XLSX from 'xlsx'

  export default {
    mixins:[metodos],
    data: () => ({
      text:'',
      snackbar:false,
      color:'',
      loading: true,
      longitud:5,
      page: 1,
      pageCount: 0,
      itemsPerPage: 40,
     

      search:'',
      productos:[],
      headers: [
        { text: 'Nombre', align: 'left',sortable: false, value: 'nomart'},
        { text: 'Familia',               value: 'familia' },
        { text: 'Categoria',             value: 'categoria' },
        { text: 'Subcategoria',          value: 'subcategoria' },
        { text: 'Tendencias',            value: 'novedades' },
        // { text: 'Destacados',         value: 'destacados' },
        { text: 'Regalo perfecto',       value: 'destacados' },
        { text: 'Primer juguete',        value: 'juguete' },

      ],
    }),

    created(){
      this.init()
    },

    methods:{

      init(){
        this.$http.get('articulos.activos').then(response =>{
          this.productos = response.body
          this.longitud = this.productos.length
          this.loading = false

          this.productos.forEach(element=>{
            element.novedades  == 1 ? element.novedades  = true: element.novedades  = false
            element.destacados == 1 ? element.destacados = true: element.destacados = false
            element.juguete    == 1 ? element.juguete    = true: element.juguete    = false

          })
        }).catch(error=>{console.log(error)})
      },

      // EXCEL
      exportar(){
        let xls = {
          data:      this.productos,
          tHeaders : ['Codigo','Nombre', 'Sal', 'Labortorio'],
          filterVal: ['codigo','nomart', 'sal', 'lab'],
          nomfile :  "Productos"
        }
        this.exportExcel()
      },

      s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
      },

      exportExcel(){
        this.productos.sort((a , b)=>{
          if (a.nomart > b.nomart) {
            return 1;
          }
          if (a.nomart < b.nomart) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });

        let data = XLSX.utils.json_to_sheet(this.productos)
        const workbook = XLSX.utils.book_new()
        const filename = 'Productos'
        XLSX.utils.book_append_sheet(workbook, data, filename)

        var wbout = XLSX.write(workbook, {
          bookType: 'xls',
          bookSST: false,
          type: 'binary'
        });

        const file = new File([new Blob([this.s2ab(wbout)])], filename + '.xls')
        console.log(file)
        
        let formData = new FormData();
        // //se crea el objeto y se le agrega como un apendice el archivo 
        formData.append('file',file);
        // /*Initialize the form data*/
        console.log('formData', formData)

        this.$http.post('pdfs',formData).then(response=> {
          // alert(response.body)
          window.location = this.$http.options.root + 'pdfs/' + filename + '.xls'
        }).catch(error=> {
          alert(error.body)
          console.log(error);
        });

      },

      novedades(item){
        item.novedades  == true? item.novedades  = 1: item.novedades  = 0;
        item.destacados == true? item.destacados = 1: item.destacados = 0;
        item.juguete    == true? item.juguete    = 1: item.juguete    = 0;
        this.$http.put('articulos.novedades/' + item.id, item).then(response=>{
          console.log(response)
          this.text = 'Articulo actualizado'
          this.color = 'success'
          this.snackbar = true
          this.init()
        }).catch(error=>{
          console.log(error)
        })
      },

    },

  }
</script>





